<template>
  <div class="content-box">
    <Loader v-if="loading" />
    <div class="full-chat-w" v-else>
      <div class="full-chat-i">
      <div class="full-chat-left b-r" v-if="session.type == 'bulk'">
          <div class="os-tabs-w os-tab b-r">
            <ul class="nav nav-tabs upper centered">
              <li class="nav-item">
                <a class="nav-link active" >
                  <i class="fal fa-upload"></i>
                  <span>Queue</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-container">
              <div class="">
                <div class="ael-head">
                  <div class="actions-left p-1">
                    <h5>{{products.length}} Products</h5>
                  </div>
                </div>
                <div class="ae-list">
                  <Loader v-if="loadingProductRail" />
                  <ProductRail :products="products" :selectedProduct="selectedProduct" @productRailInterface="changeProduct" />
                </div>
              </div>
            <!-- </div> -->
          </div>
        </div>

        <div class="full-chat-left scrollable">
          <div class="os-tabs-w os-tab">
            <ul class="nav nav-tabs upper centered">
              <li class="nav-item" v-for="tab in tabOptions" @click="changeTab(tab)" :key="tab.name">
                <a class="nav-link" :class="{'active': selectedTab == tab.name}">
                  <i :class="tab.icon"></i>
                  <span>{{tab.name}}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-container custom">
            <div v-show="selectedTab == 'Images'">
              <EmptyState v-if="selectedProduct == null">
                <div slot="empty_state_text">Scan a product to continue</div>
              </EmptyState>
              <div v-else>
                <Loader v-if="loadingRail" />
                <imageRail :images="getImages" :current-session="session.id_photodesk_session" :finalImages="finalImages" @deleteInterface="getProductImages" v-else/>
              </div>
            </div>
            <div v-show="selectedTab == 'Comments'" @click="getProductComments">
              <ProductComments :comments="selectedProductComments" />
            </div>
            <div v-show="selectedTab == 'Associations'" >
              <ProductAssociates :associates="selectedProductAssociates" :selectedProduct="selectedProduct" @productAssociatesInterface="handleProductAssociates"/>
            </div>
            <div v-show="selectedTab == 'History'" @click="getSessionProducts">
              <Loader v-if="loadingProductRail" />
              <ProductRail :products="products" :selectedProduct="selectedProduct" @productRailInterface="changeProduct" v-else/>
            </div>
          </div>
        </div>
        <div class="full-chat-middle">
          <div class="chat-head" style="padding: 5px 20px;">
            <div class="user-info">
              <span >
                <div class="element-wrapper" v-if="showStyleGuide == true">
                  <div class="element-warning text-danger" v-if="updateRequired == false && sequenceUpdateRequired == false">
                    <div style="padding: 10px 15px 10px 50px;">You are viewing styling guide, click show images to go back to your product</div>
                  </div>
                </div>
                <div class="element-wrapper" v-else>
                  <div class="element-search" v-if="updateRequired == false && sequenceUpdateRequired == false">
                    <input placeholder="Search for product..." type="text" v-on:keyup.enter="getProduct" v-model="productIdentifier" />
                  </div>
                </div>

                <button class="mr-2 mb-2 btn btn-success btn-sm large-button" type="button" @click="updateFinalImages" v-if="updateRequired == true"> Update Images</button>
              </span>
            </div>
            
            <div class="user-actions">
              <i class="fas fa-sync mr-2" :class="{'fa-spin' : resequencingImages == 'pending'}" @click="refreshImages"></i>

              <button class="btn btn-primary btn-sm" type="button" @click="toggleStyleGuide" > Show {{showStyleGuide == true ? 'Images' : 'Style Guide'}}</button>
            </div>
          </div>
          <div class="chat-head" style="padding: 5px 20px;">
            <div class="user-info">
              <span >
                <div class="element-wrapper">
                  <div class="element-warning text-black">
                    <div style="padding: 10px 15px 10px 50px;">Having issues setting up CloudShift?</div>
                  </div>
                </div>
              </span>
            </div>
            <div class="user-actions">
              <button class="btn btn-outline-secondary btn-sm" type="button" @click="openSOP" > Troubleshooting Guide</button>
            </div>
          </div>
          <div class="chat-content-w">
            <EmptyState v-if="selectedProduct == null">
              <div slot="empty_state_text">Scan a product to continue</div>
            </EmptyState>
            <div v-else-if="showStyleGuide">
              <!-- show selectedproduct images if available -->
              <div v-if="styleGuideProduct">
                <Loader :type="'image'" v-if="loadingStyleGuideImages" />
                <Workspace :product="selectedProduct" :final-images="styleGuideProductImages" :type="'styleguide'"/>
              </div>
              <div v-else-if="styleGuide">
                <embed :src="styleGuide" width="100%" height="100%" v-if="styleGuide.endsWith('pdf')" />
                <img width="100%" :src="styleGuide" v-else/>
              </div>
              <div v-else class="text-center mt-5">
                No Style Guide defined for this product
              </div>

            </div>
            <div v-else>
              <Loader :type="'image'" v-if="loadingImages" />
              <Workspace :product="selectedProduct" :final-images="finalImages" :images="images" @deleteInterface="markDelete" v-else/>
            </div>
          </div>
          <div class="chat-controls">
            <div class="chat-input">
                <textarea class="form-group form-control" placeholder="Type your comment..." type="text" contenteditable v-model="productComment" />
            </div>
            <div class="chat-input-extra">
              <div class="chat-extra-actions">
                <a>
                  <i class="os-icon os-icon-mail-07"></i>
                </a>
              </div>
              <div class="chat-btn">
                <a class="btn btn-primary btn-sm" @click="addProductComment">Add Comment</a>
              </div>
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable">
          <EmptyState v-if="selectedProduct == null">
            <div slot="empty_state_text">..</div>
          </EmptyState>

          <ProductInfoBlock :selectedProduct="selectedProduct" :session="session" :pendingRefresh="pendingRefresh" @refreshInterface="pendingRefresh = 1" v-if="!showStyleGuide"/>

          <RelatedProductRail :selectedProduct="selectedProduct" :photodeskRelatives="selectedProductRelatives" :type="'photodesk'" @clickInterface="getStyleGuideImages" v-else/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import EmptyState from '@/components/common/EmptyState'

import Workspace from '@/components/photodesk/Workspace'
import ProductRail from '@/components/common/SessionAdd/ProductRail'
import ProductInfoBlock from '@/components/common/SessionAdd/ProductInfoBlock'
import RelatedProductRail from '@/components/common/SessionAdd/RelatedProductRail'
import ProductComments from '@/components/productdesk/ProductComments'
import ProductAssociates from '@/components/productdesk/ProductAssociates'
import ImageRail from '@/components/photodesk/ImageRail'

import Product from '@/mixins/product'

import At from 'vue-at'
import AtTa from 'vue-at/dist/vue-at-textarea'
import { remove } from 'lodash'
import DnD from '@/mixins/dragdrop.js'

export default {
  props: ['id_session'],
  components: {
    Loader,
    EmptyState,
    At,
    AtTa,
    Workspace,
    ImageRail,
    ProductRail,
    ProductInfoBlock,
    RelatedProductRail,
    ProductComments,
    ProductAssociates
  },
  mixins: [DnD, Product],
  data: function () {
    return {
      tabOptions: [
        {
          name: 'Images',
          icon: 'fal fa-image'
        },
        {
          name: 'Comments',
          icon: 'fal fa-comments'
        },
        {
          name: 'Associations',
          icon: 'fal fa-cubes'
        },
        {
          name: 'History',
          icon: 'fal fa-history'
        }
      ],
      showStyleGuide: false,
      styleGuide: '',
      selectedTab: 'Images',
      productIdentifier: '',
      session: {},
      products: [],
      selectedProduct: '',
      selectedProductComments: '',
      selectedProductAssociates: '',
      selectedProductRelatives: '',
      images: [],
      finalImages: [],
      productComment: '',
      loading: false,
      loadingImages: true,
      loadingRail: true,
      loadingProductRail: false,
      loadingProductComments: false,
      resequencingImages: '',
      doRefresh: true,
      pendingRefresh: 0,
      styleGuideProduct: '',
      loadingStyleGuideImages: true,
      styleGuideProductImages: ''
    }
  },
  mounted: function () {
    var self = this
    this.getSessionDetails()

    var channel = this.$pusher.subscribe('image')
    channel.bind('received', function (data) {
      console.log(data.id_photodesk_session)
	    if (
	      data.id_photodesk_session == self.session.id_photodesk_session
	    ) {
        self.doRefresh = false
        self.getProductImages()
	    }
    })

    var product_channel = this.$pusher.subscribe('product')
    product_channel.bind('cacheupdated', function (data) {
      console.log(data)
      if (parseInt(data.id_product) == parseInt(self.selectedProduct.id_product)) {
        self.updateProductPhotodesk(self.session.id_photodesk_session)
      }
    })
  },
  methods: {
    openSOP: function() {
      const url = 'https://docs.google.com/document/d/1G7BXCmi8jI3dUHp0QPvk5pWR8fa2K_r_NKtbL6L6_mQ/edit#heading=h.mz9l25qg3hce'
      window.open(url, '_blank').focus();
    },
    getSessionDetails: function () {
      var self = this

      const url = '/photodesk/session/show'
      let data = {
        id_photodesk_session: self.id_session
      }

      self.loadingImages = true
      self.loadingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.session = response.data.session
          self.products = response.data.products
          self.selectedProduct = response.data.active_product

          self.selectedProductRelatives = response.data.related_products
            .filter(product => {
              if (
                product.shoot_count > 0
              ) {
                return true
              }
              return false
            })
          self.getProductImages()
        })
        .catch(function (error) {
          console.log(error)
          // self.$store.dispatch('updateToast', {
          // 	text: error.response.data.message,
          // 	show: true
          // })
        })
    },
    getSessionProducts: function () {
      var self = this

      const url = '/photodesk/session/show'
      let data = {
        id_photodesk_session: self.id_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.products = response.data.products
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
          	text: 'Error getting history',
          	show: true
          })
        })
    },
    getProductImages: function () {
      var self = this
      const url = '/imagedesk/image/all'

      if (!self.selectedProduct && !self.selectedProduct.id_product) {
        return
      }

      let data = {
        id_photodesk_session: self.id_session,
        id_product: self.selectedProduct.id_product
      }
      self.loadingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.images = response.data.images
          // if (self.doRefresh == true) {
          self.getFinalSequence()
          // }
          self.loadingRail = false
          self.doRefresh = true
        })
        .catch(function (error) {
          self.loadingRail = false
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
          console.log(error)
        })
    },
    getFinalSequence: function (style_guide = false) {
      var self = this
      const url = '/imagedesk/image/final'
      let data = {
        id_product: !style_guide ? self.selectedProduct.id_product : self.styleGuideProduct
      }

      self.loadingImages = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (style_guide === false) {
            self.finalImages = response.data.final_images
          } else {
            self.styleGuideProductImages = response.data.final_images
          }
          self.loadingImages = false
          self.loadingStyleGuideImages = false
          self.doRefresh = true
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response.data.message,
            show: true
          })
          self.loadingImages = false
          self.loadingStyleGuideImages = false
        })
    },
    updateFinalImages: function () {
      var self = this
      const url = '/imagedesk/image/update/final'
      let data = {
        id_pairs: self.$store.getters.updateImagesSet,
        id_product: self.selectedProduct.id_product,
        order: self.$store.getters.updateSequenceSet,
        id_photodesk_session: self.id_session
      }
      self.resequencingImages = 'pending'
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateimagesUpdateRequired', false)
          self.$store.dispatch('updateimagesUpdateSet', [])
          self.$store.dispatch('updateSequenceUpdateSet', [])
          self.getProductImages()
          self.getFinalSequence()
          self.resequencingImages = 'done'
          setTimeout(function () {
            self.resequencingImages = ''
          }, 2000)
        })
        .catch(function (error) {
          console.log(error.response)
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },
    updateFinalSequence: function () {
      var self = this
      const url = '/imagedesk/image/update/sequence'
      let data = {
        order: self.$store.getters.updateSequenceSet,
        id_product: self.selectedProduct.id_product
      }
      self.resequencingImages = 'pending'
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateSequenceUpdateRequired', false)
          self.getFinalSequence()
          self.getProduct()
          self.resequencingImages = 'done'
          setTimeout(function () {
            self.resequencingImages = ''
          }, 2000)
        })
        .catch(function (error) {
          console.log(error.response)
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },
    refreshImages: function () {
      this.getProductImages()
    },
    getProduct: function () {
      var self = this
      const url = '/productdesk/product/add'

      let data = {
        identifier: self.productIdentifier,
        id_photodesk_session: self.id_session
      }

      self.clearProductVariables()
      self.loadingImages = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data
          self.selectedProductRelatives = response.data.related_products
            .filter(product => {
              if (
                product.shoot_count > 0
              ) {
                return true
              }
              return false
            })
          self.getProductImages()
          self.loadingImages = false
          self.productIdentifier = ''
          self.$store.dispatch('updateimagesUpdateRequired', false)
          self.$store.dispatch('updateimagesUpdateSet', [])
          self.$store.dispatch('updateSequenceUpdateSet', [])
        })
        .catch(function (error) {
          console.log(error.response)
          self.selectedProduct = null
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
          self.loadingImages = false
        })
    },
    changeProduct: function (data) {
      this.clearProductVariables()
      this.productIdentifier = data.item_identifier
      this.getProduct()
    },
    clearProductVariables: function () {
      this.selectedProduct = ''
      this.selectedProductComments = ''
      this.selectedProductRelatives = ''
      this.styleGuideProduct = ''
      this.styleGuideProductImages = ''
      this.images = ''
      this.finalImages = ''
      this.styleGuide = ''
      this.showStyleGuide = false
      this.$store.dispatch('updateimagesUpdateRequired', false)
      this.$store.dispatch('updateSequenceUpdateRequired', false)
    },
    markDelete: function (data) {
      var self = this
      var image = data

      if (image.is_marked_delete && image.is_marked_delete == 1) {
        if (self.updateImagesSet) {
          var newSet = remove(self.updateImagesSet, function (item) {
            return item.id_product_image === parseInt(image.id_product_image)
          })
          self.$store.dispatch('updateimagesUpdateSet', self.updateImagesSet)
          if (self.updateImagesSet == 0) {
            self.$store.dispatch('updateimagesUpdateRequired', false)
          }
        }
        image.is_marked_delete = 0
        return true
      }

      if (self.updateImagesSet) {
        self.updateImagesSet.push({
          id_product_image: image.id_product_image,
          id_image: null
        })
      }
      self.$set(image, 'is_marked_delete', 1)
      self.$store.dispatch('updateimagesUpdateRequired', true)
      self.$store.dispatch('updateimagesUpdateSet', self.updateImagesSet)
    },
    getProductComments: function () {
      var self = this
      const url = '/productdesk/product/comment'

      let data = {
        id_product: self.selectedProduct.id_product
      }
      self.loadingProductComments = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProductComments = response.data.product_comments
          self.loadingProductComments = false
        })
        .catch(function (error) {
          console.log(error.response)
        })
    },
    addProductComment: function () {
      var self = this
      const url = '/productdesk/product/comment/add'
      let data = {
        id_product: self.selectedProduct.id_product,
        comment: self.productComment
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productComment = ''
          self.getProductComments()
          console.log(response)
        })
        .catch(function (error) {})
    },
    toggleStyleGuide () {
      var self = this

      self.showStyleGuide = !self.showStyleGuide

      if (self.showStyleGuide == false) {
        return
      }

      const url = '/orgdesk/styleguide/view'
      let data = {
        id_product: self.selectedProduct.id_product
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.styleGuide = response.data.guide.style_guide
          console.log(response)
        })
        .catch(function (error) {})
    },
    getStyleGuideImages: function (data) {
      // get images for style guide selected product
      this.styleGuideProduct = data
      this.getFinalSequence(true)
    },
    changeTab: function (tab) {
      this.selectedTab = tab.name
      if (tab.name == 'Comments') {
        this.getProductComments()
      }
      if (tab.name == 'History') {
        this.getSessionProducts()
      }
      if (tab.name == 'Associations') {
        this.getProductAssociates()
      }
    },
    handleProductAssociates: function (data) {
      this.getProductAssociates()
    }
  },
  computed: {
    getImages () {
      return this.images
    },
    updateRequired () {
      return this.$store.getters.updateRequired
    },
    sequenceUpdateRequired () {
      return this.$store.getters.sequenceUpdateRequired
    },
    clientUsers () {
      return this.$store.getters.clientUsers
    }
  }
}
</script>

<style scoped>
.large-button {
  height: 37px;
}
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}
.element-wrapper .element-search input {
  background-color: #fff;
  border-radius: 0px !important;
}

.element-wrapper {
  padding-bottom: 0rem !important;
}

.os-tab {
  position: absolute;
  top: 0;
  width: 340px;
  background: #f2f4f8;
  z-index: 999;
}

.tab-container {
  margin-top: 53px;
}

.full-chat-w .chat-content-w {
    height: calc(100vh - 270px) !important;
}

</style>
